<template>
	<div style="background:linear-gradient(180deg, #2D3947 0%, #3F3F3F 50%, #2F2F2F 100%)">
		<BusinessBanner />
		<div class="content-zsy">
			<div class="title-wrap">
				<h3>사업자 지원 안내</h3>
				<h4>구매대행/수입 사업자 지원 안내</h4>
			</div>
			
			<div class="summary">
				고로켓고에서 구매대행/수입 사업자 회원 서비스를 시작합니다.<br>
				첫 번째로 사업자 지원 프로모션을 준비했습니다.<br>
				사업자 회원님의 비즈니스에 작은 도움이 되었으면 합니다.
			</div>
			
			<el-row class="support-list">
				<el-col :xs="12" :sm="8" class="support-item" >
					<div class="child">
						<div class="title">포장용 폴리백 지원</div>
						<div class="img-box"><img src="../../assets/list/document_biz_support_img1.png" alt="" class="img-responsive"></div>
						<p>
							택배배송용 폴리백을 무료로<br>
							지원합니다. (배송신청서 당 1매)
						</p>
					</div>
				</el-col>
				<el-col :xs="12" :sm="8" class="support-item" >
					<div class="child">
						<div class="title">장기보관</div>
						<div class="img-box"><img src="../../assets/list/document_biz_support_img2.png" alt="" class="img-responsive"></div>
						<p>
							장기보관 수수료를 면제합니다.<br>
							(최대3개월)
						</p>
					</div>
				</el-col>
				<el-col :xs="12" :sm="8" class="support-item">
					<div class="child">
						<div class="title">폐기 수수료 면제</div>
						<div class="img-box"><img src="../../assets/list/document_biz_support_img3.png" alt="" class="img-responsive"></div>
						<p>
							중국 내에서 폐기 시<br>
							처리비용을 면제해드립니다.
						</p>
					</div>
				</el-col>
				<el-col :xs="12" :sm="8" class="support-item">
					<div class="child">
						<div class="title">추천인 등록 시</div>
						<div class="img-box"><img src="../../assets/list/document_biz_support_img4.png" alt="" class="img-responsive"></div>
						<p>
							추천하신 분과 추천받은 분<br>
							모두 모두 드립니다.
						</p>
					</div>
				</el-col>
				<el-col :xs="12" :sm="8" class="support-item">
					<div class="child">
						<div class="title">500건 이상 진행 시</div>
						<div class="img-box"><img src="../../assets/list/document_biz_support_img5.png" alt="" class="img-responsive"></div>
						<p>
							누적 500건 이상 시<br>
							사업자 회원 파트너 등급으로 변경
						</p>
					</div>
				</el-col>
				<el-col :xs="12" :sm="8" class="support-item">
					<div class="child">
						<div class="title">사업자 전용 상담</div>
						<div class="img-box"><img src="../../assets/list/document_biz_support_img6.png" alt="" class="img-responsive"></div>
						<p>
							사업자 회원 전용 카톡 상담으로<br>
							더욱 빠르게!
						</p>
					</div>
				</el-col>
				<el-col :xs="12" :sm="8" class="support-item">
					<div class="child">
						<div class="title">등급이전</div>
						<div class="img-box"><img src="../../assets/list/document_biz_support_img7.png" alt="" class="img-responsive"></div>
						<p>
							타배대지 이용실적<br>
							그대로 등급이전
						</p>
					</div>
				</el-col>
				<el-col :xs="12" :sm="8" class="support-item">
					<div class="child">
						<div class="title">신규가입쿠폰</div>
						<div class="img-box"><img src="../../assets/list/document_biz_support_img8.png" alt="" class="img-responsive"></div>
						<p>
							신규가입 시<br>
							알찬 중국 전용 8종 쿠폰팩
						</p>
					</div>
				</el-col>
				<el-col :xs="12" :sm="8" class="support-item">
					<div class="child">
						<div class="title">개봉 환불 금지 스티커</div>
						<div class="img-box"><img src="../../assets/list/document_biz_support_img9.png" alt="" class="img-responsive"></div>
						<p>
							환불 금지 스티커를<br>
							무료로!
						</p>
					</div>
				</el-col>
			</el-row>
			
			<div class="mid-text mb100 " >
				사업자 회원님, 지원 프로모션도 물론 중요하지만<br>
				배대지는 배대지 본연의 업무를 <br class="visible-xs">충실하게 하는 것이 가장 중요하다고 생각합니다.
			</div>
			
			<div class="text-box mb20">
				<div class="head">고로켓고의 사업자 서비스는</div>
				<ul class="num-list type-2 mt5">
					<li>
						<div class="num">1. </div>
						<div class="content">회원님과의 소통을 우선시 하겠습니다.</div>
					</li>
					<li>
						<div class="num">2. </div>
						<div class="content">사진만 찍어주는 검수가 아닌 실물검수를 합니다.</div>
					</li>
					<li>
						<div class="num">3. </div>
						<div class="content">비정상 상황 발생 시 즉시 안내를 드려 상황을 공유하겠습니다.</div>
					</li>
					<li>
						<div class="num">4. </div>
						<div class="content">합리적 비용으로 회원님 부담을 줄여드립니다.</div>
					</li>
					<li>
						<div class="num">5. </div>
						<div class="content">안심보상으로 마음놓고 판매에만 집중하세요.</div>
					</li>
					<li>
						<div class="num">6. </div>
						<div class="content">회원님의 소싱/판매 아이템 정보 보호에 최선을 다합니다.</div>
					</li>
				</ul>
			</div>
			<div class="text-box">
				회원님의 의견을 적극 반영해서 회원님의 비즈니스 파트너로 안심할 수 있는 상생하는 배대지가 되겠습니다.<br><br>
				고로켓고은 쿠팡,네이버 등 국내 외 온라인 스토어에서 겸업/판매 및 자사몰을 운영하지 않으며<br class="hidden-xs">
				회원님의 소싱/판매 아이템 정보 보호를 최우선하겠습니다.<br><br>
				구매대행 / 수입 사업자 회원님의 성공 비즈니스를 기원합니다.<br><br>
				사업자 회원님의 상품 포장 시 로고가 없는 무지 박스 테이프를 사용합니다.
			</div>
			<br><br><br>
			

			
		</div>
		
	</div>
</template>

<script>
	import BusinessBanner from '../../components/BusinessBanner.vue'
	export default {
		components: {
			BusinessBanner
		},
		data() {
			return{
	
			}
		},
		methods: {
		
		}
		
	}
</script>

<style scoped>
	.title-wrap{
		text-align: center;
		margin: 60px 0;
	}
	.title-wrap h3 {
	    font-size: 20px;
	    font-weight: bold;
	    color: var(--main-color);
	    margin: 0 0 19px;
	}
	.title-wrap h4 {
	    font-weight: 700;
	    font-size: 36px;
	    line-height: 1.34;
	    margin: 0;
		color: #fff;
	}
	.summary{
		margin-top: 10px;
		line-height: 30px;
		color: #fff;
		font-size: 20px;
		text-align: center;
		padding:0 10px;
		
	}
	.support-list{
		padding: 40px 0;
	}
	.support-item{
		padding: 0 10px 20px;
	}
	.support-list .child{
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		height: 355px;
		border-radius: 15px;
		text-align: center;
		transition: 0.25s;
		overflow: hidden;
		background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.08) 100%);
		position: relative;
	}
	.support-list .child:hover{
		background: rgba(255, 255, 255, 0.4); 
	}
	.support-list .child .title{
		font-weight: 700;
		font-size: 18px;
		line-height: 22px;
		color: #FFFFFF;
		margin-bottom: 15px;
		position: relative;
	}
	.support-list .child .img-box{
		filter: drop-shadow(0px 10.8108px 10.8108px rgba(0, 0, 0, 0.25));
	}
	.support-list .child p{
		margin: 10px 0 0;
		font-size: 12px;
		line-height: 2;
		text-align: center;
		color: #FFFFFF;
		position: relative;
	}
	.mid-text{
		font-weight: 600;
		font-size: 24px;
		line-height: 1.4;
		text-align: center;
		color: #FFFFFF;
	}
	.text-box{
		padding: 45px;
		background: #111111;
		border-radius: 30px;
		font-size: 17px;
		line-height: 40px;
		color: #FFFFFF;
	}
	.text-box .head {
	    font-weight: 700;
	    font-size: 24px;
	    line-height: 29px;
	    color: #FFFFFF;
		padding-bottom: 5px;
	}
	ul.num-list {
	    margin: 0;
	    padding: 0;
	    list-style: none;
	}
	.num-list li{
		display: flex;
		gap: 0 5px;
		font-size: 17px;
		line-height: 40px;
		
	}
	ul.num-list .content {
	    flex: 1;
	}
	
	
	.mb20{
		 margin-bottom: 20px !important;
	}
	.mb100 {
	    padding-bottom: 100px !important;
	}
	.visible-xs {
	    display: none !important;
	}
	.img-responsive{
		display: block;
		max-width: 100%;
		height: auto;
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 992px;
			margin: 0 auto;
			padding: 0 auto;
		}
		
	}
	@media (max-width: 768px) {	
		.summary{
			font-size: 15px;
		}
		.mid-text{
			font-size: 15px;
			line-height: 29px;
			margin: 56px 0;
		}
		
		
		.visible-xs {
		    display:block !important;
		}
		.hidden-xs {
			display: none !important;
		}
	}
	
</style>